import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Icon from '@material-ui/core/Icon';
// core components
import CardBody from "@app/components/Card/CardBody";
// IMG
import featureCardStyle from "@app/assets/jss/material-kit-pro-react/components/cards/featureCardStyle";

const FeatureCard = props => {
    const { classes } = props;

    return (
        <CardBody className={classes.textCenter}>
            <Icon className={classes.iconRoot}>
                <img className={classes.imageIcon} src={props.icon}/>
            </Icon>
            <h3 className={classes.cardTitle}>
                {props.title}
            </h3>
            <p className={classes.description}>
                <b>{props.description}</b>
            </p>
            {props.citation && <p className={classes.description}>
                *&nbsp;<sub>{props.citation}</sub>
            </p>}
        </CardBody>
        );
    }
    
export default withStyles(featureCardStyle)(FeatureCard);